import { createGlobalStyle } from "styled-components";

const LoginStyle = createGlobalStyle`
    .login-left-wrap{
        width: 60%;
        img{
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: 270px 0px;
        }
    }
`;

export default LoginStyle;